import { ContactForm } from "../components/ContactForm";

export function ContactSection({ uni }) {
  return (
    <section
      id="contact"
      className="scroll-mt-28 rounded-2xl border border-maroon-900/20 bg-gradient-to-br from-maroon-900 to-maroon-800 px-6 py-10 text-center text-white shadow-lg shadow-maroon-900/25 sm:px-10"
      aria-labelledby="contact-heading"
    >
      <h1 id="contact-heading" className="text-2xl font-bold sm:text-3xl">
        Visit {uni.featuredCampus?.name ?? "our campus"}
      </h1>
      <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-maroon-100 sm:text-base">
        Reach out for admissions, campus tours, or partnership inquiries. We’re here to
        help you take the next step.
      </p>
      <div className="mt-8 flex flex-wrap justify-center gap-4 text-sm">
        <a
          href={`mailto:${uni.footer.email}`}
          className="inline-flex items-center gap-2 rounded-xl bg-white px-5 py-3 font-semibold text-maroon-900 shadow-md transition hover:bg-maroon-50"
        >
          Email admissions
        </a>
        <a
          href={uni.mainWebsite}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 rounded-xl border border-white/40 px-5 py-3 font-semibold text-white transition hover:bg-white/10"
        >
          Official website
        </a>
      </div>
      <div className="mx-auto mt-8 max-w-3xl rounded-2xl border border-white/20 bg-white/5 p-5 sm:p-6">
        <h2 className="text-left text-lg font-semibold text-white">Contact form</h2>
        <p className="mt-1 text-left text-sm text-maroon-100">
          Send us your inquiry and your email app will open with your pre-filled message.
        </p>
        <ContactForm toEmail={uni.footer.email} />
      </div>
    </section>
  );
}

export function ContactPage({ uni }) {
  return (
    <main id="main" className="flex-1">
      <div className="mx-auto max-w-6xl px-4 py-8 sm:px-6 sm:py-10">
        <ContactSection uni={uni} />
      </div>
    </main>
  );
}
